import React, {InputHTMLAttributes} from "react";
import {UseFormRegisterReturn} from "react-hook-form/dist/types/form";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    suffixElement?: React.ReactNode
    prefixElement?: React.ReactNode
    inputClassName?: string | object
    register?: UseFormRegisterReturn,
    error?: string,
    onChange?: (e) => void,
    name?: string,
    onInput?: (e) => void;
}

export default function Input({prefixElement, suffixElement, inputClassName, className, name, onInput, register, error, onChange,...props}:  InputProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (register && typeof register.onChange === "function") {
            register.onChange(event);
        }

        if (typeof onChange === "function") {
            onChange(event);
        }
    };

    const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
        if (typeof onInput === "function") {
            onInput(event);
        }
    };

    const inputName = name ?? register?.name;

    return (
        <>
            <div className={`border border-gray-500 flex items-center h-10 space-x-2 ${error ? 'border-red-500' : 'border-gray-500'} ${className}`}>
                {prefixElement ? <div className='h-full flex items-center'>{prefixElement}</div> : null}
                <input
                    {...register}
                    name={inputName}
                    className={`outline-none h-full max-w-full px-3 flex-1 placeholder:font-light ${inputClassName}`}
                    {...props}
                    onChange={handleChange}
                    onInput={handleInput}
                />
                {suffixElement ? <div className='h-full flex items-center'>{suffixElement}</div>  : null}
            </div>
            <small className='text-red-500 font-light text-xs'>{error}</small>
        </>

    )
}
